'use strict';

import * as moment from 'moment';

function OPPostponeDialogController($scope, $mdDialog, dueAt) {
  'ngInject';

  $scope.dueAt = moment(dueAt);
  $scope.labelDueAt = $scope.dueAt.format('LLLL');

  $scope.save = function() {
    $mdDialog.hide({
      comments: $scope.comments,
      dueAt: $scope.dueAt.toDate()
    });
  };

  $scope.cancel = function() {
    $mdDialog.cancel();
  };
}

export default OPPostponeDialogController;
